export default "__VITE_ASSET__1e2d944f__"